import { EligibleJobAdapter } from './adapters';
import { eligibleJobsApi } from './eligibleJobsApi';
import { IGetEligibleJobsParams, IGetEligibleJobsResult } from './types';

async function getEligibleJobs(
  params: IGetEligibleJobsParams,
): Promise<IGetEligibleJobsResult> {
  const response = await eligibleJobsApi.getEligibleJobs(params);
  return EligibleJobAdapter.toGetEligibleJobsResult(response);
}

export const eligibleJobsService = {
  getEligibleJobs,
};
